import { Handshake, Pencil, Trash2 } from "lucide-react";
import { fmtTL } from "../../lib/format";

const HEADERS = ["Hizmet", "Birim", "Gelir", "Gider", "Fark", "Geçerli Şubeler (bu proje)", "Durum", ""];
const alignRight = (i) => (i >= 2 && i <= 4) || i === 7;

// Projedeki hizmetler tablosu (gelir/gider/fark + şube kapsamı)
export default function SvcTable({ rows, locs, svcFin, onAssign, onEdit, onRemove }) {
  return (
    <table className="w-full tbl">
      <thead className="bg-slate-50">
        <tr>
          {HEADERS.map((h, i) => <th key={h} className={`px-3 py-2 text-[10px] uppercase tracking-wider text-slate-600 font-semibold ${alignRight(i) ? "text-right" : "text-left"}`}>{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((s) => {
          const locCount = (s.location_ids || []).filter((id) => locs.some((l) => l.id === id)).length;
          const fin = svcFin(s.id);
          return (
            <tr key={s.id} className="border-t border-slate-100">
              <td className="px-3 py-2 text-xs font-medium">{s.name}{s.scope === "projects" && <span className="ml-1.5 px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 text-[9px] font-bold" data-testid={`svc-scope-${s.id}`}>PROJEYE ÖZEL</span>}</td>
              <td className="px-3 py-2 text-xs">{s.unit}</td>
              <td className="numeric-cell px-3 py-2 text-xs text-emerald-700 font-semibold" data-testid={`svc-revenue-${s.id}`}>{fmtTL(fin.revenue)}</td>
              <td className="numeric-cell px-3 py-2 text-xs text-red-700 font-semibold" data-testid={`svc-expense-${s.id}`}>{fmtTL(fin.expense)}</td>
              <td className={`numeric-cell px-3 py-2 text-xs font-bold ${fin.diff >= 0 ? "text-emerald-700" : "text-red-700"}`} data-testid={`svc-diff-${s.id}`}>{fmtTL(fin.diff)}</td>
              <td className="px-3 py-2 text-xs" data-testid={`svc-locs-${s.id}`}>{(s.location_ids || []).length > 0 ? `${locCount} şube` : "Tümü"}</td>
              <td className="px-3 py-2 text-xs">{s.status}</td>
              <td className="px-3 py-2 text-right whitespace-nowrap">
                <button onClick={onAssign} title="Şube kartlarından taşeron ve fiyat atayın" className="text-emerald-700 hover:text-emerald-900 mr-2" data-testid={`svc-assign-${s.id}`}><Handshake className="w-3.5 h-3.5" /></button>
                <button onClick={() => onEdit(s)} className="text-slate-600 hover:text-slate-900 mr-2" data-testid={`svc-edit-${s.id}`}><Pencil className="w-3.5 h-3.5" /></button>
                <button onClick={() => onRemove(s)} title="Yalnızca bu projeden kaldır — Hizmetler menüsü ve diğer projeler etkilenmez; tamamen silmek için Hizmetler menüsünü kullanın" data-testid={`svc-remove-proj-${s.id}`}
                  className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-red-300 bg-red-50 text-[11px] font-semibold text-red-700 hover:bg-red-100">
                  <Trash2 className="w-3 h-3" /> Projeden Kaldır
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
